import dalImg from "../assets/images/dal.jpg";
import drungImg from "../assets/images/drung.jpg";
import gulmargImg from "../assets/images/gulmarg.jpg";
import gondolaImg from "../assets/images/gondola.jpg";
import sonmargImg from "../assets/images/sonmarg.jpg";
import pahalgamImg from "../assets/images/pahalgam.jpg";

interface ImageProps {
  src: string;
  alt: string;
}

interface ICard {
  description: string;
  image?: ImageProps;
  title: string;
  rating: number;
  slug: string;
}

export const TrendingPackages: ICard[] = [
  {
    title: "Skiing in Gulmarg",
    description:
      "Experience the thrill of skiing on the snow-covered slopes of Gulmarg, a paradise for adventure enthusiasts.",
    image: {
      src: "/images/courses/sk2.jpg",
      alt: "Skiing in Gulmarg",
    },
    rating: 5,
    slug: "Gulmarg",
  },
  {
    title: "Gondola Ride in Gulmarg",
    description:
      "Enjoy a breathtaking gondola ride in Gulmarg, the highest cable car ride in Asia, with stunning views of the Himalayas.",
    image: {
      src: gondolaImg,
      alt: "Gondola Ride in Gulmarg",
    },
    rating: 4.5,
    slug: "Gulmarg",
  },
  {
    title: "Strawberry Valley Tour in Gulmarg",
    description:
      "Visit the picturesque Strawberry Valley in Gulmarg and indulge in the serenity and natural beauty of the place.",
    image: {
      src: "/images/packages/strawberry.jpg",
      alt: "Strawberry Valley in Gulmarg",
    },
    rating: 4.7,
    slug: "Gulmarg",
  },
  {
    title: "Trekking in Sonmarg",
    description:
      "Explore the beautiful trails of Sonmarg with our guided trekking tours, perfect for both beginners and experienced trekkers.",
    image: {
      src: "/images/packages/trek.jpg",
      alt: "Trekking in Sonmarg",
    },
    rating: 4.8,
    slug: "Sonmarg",
  },
  {
    title: "Horse Riding in Sonmarg",
    description:
      "Enjoy an exhilarating horse ride through the lush meadows and beautiful landscapes of Sonmarg.",
    image: {
      src: sonmargImg,
      alt: "Horse Riding in Sonmarg",
    },
    rating: 4.6,
    slug: "Sonmarg",
  },
  {
    title: "Fishing in Sonmarg",
    description:
      "Relax by the pristine rivers of Sonmarg and enjoy a peaceful fishing experience amidst the scenic beauty.",
    image: {
      src: "/images/packages/fishing2.jpg",
      alt: "Fishing in Sonmarg",
    },
    rating: 4.5,
    slug: "Sonmarg",
  },
  {
    title: "Houseboat Stay on Dal Lake",
    description:
      "Stay in a traditional houseboat on Dal Lake and enjoy the tranquil surroundings and mesmerizing views.",
    image: {
      src: "/images/packages/houseboat.jpg",
      alt: "Houseboat Stay on Dal Lake",
    },
    rating: 4.7,
    slug: "Dal",
  },
  {
    title: "Shikara Ride on Dal Lake",
    description:
      "Experience the serene beauty of Dal Lake with a peaceful shikara ride, a unique experience in Kashmir.",
    image: {
      src: dalImg,
      alt: "Shikara Ride on Dal Lake",
    },
    rating: 4.8,
    slug: "Dal",
  },
  {
    title: "Kashmir Valley Tour",
    description:
      "Experience the best of Kashmir with our comprehensive valley tour, including visits to Srinagar, Gulmarg, Sonmarg, and Pahalgam.",
    image: {
      src: "/images/packages/vacation.jpg",
      alt: "Kashmir Valley Tour",
    },
    rating: 4.9,
    slug: "Kashmir",
  },
  {
    title: "Ladakh Adventure Tour",
    description:
      "Embark on an exhilarating adventure through Ladakh, exploring high-altitude deserts, serene monasteries, and the stunning Pangong Lake.",
    image: {
      src: "/images/packages/ladakh.jpg",
      alt: "Ladakh Adventure Tour",
    },
    rating: 4.9,
    slug: "Ladakh",
  },
  {
    title: "Romantic Honeymoon in Kashmir",
    description:
      "Experience a romantic getaway with your loved one in the beautiful valleys of Kashmir, featuring houseboat stays, shikara rides, and candlelit dinners.",
    image: {
      src: "/images/packages/honeymoon.jpg",
      alt: "Romantic Honeymoon in Kashmir",
    },
    rating: 4.8,
    slug: "Kashmir",
  },
  {
    title: "Couple Retreat in Gulmarg",
    description:
      "A serene retreat for couples in Gulmarg, featuring luxury accommodations, spa sessions, and leisure activities amidst the snow-capped mountains.",
    image: {
      src: "/images/packages/romantic.jpg",
      alt: "Couple Retreat in Gulmarg",
    },
    rating: 4.7,
    slug: "Gulmarg",
  },
  {
    title: "Cultural Heritage Tour of Kashmir",
    description:
      "Discover the rich cultural heritage of Kashmir with guided tours of ancient temples, Mughal gardens, and traditional crafts workshops.",
    image: {
      src: "/images/packages/kashmir.jpg",
      alt: "Cultural Heritage Tour of Kashmir",
    },
    rating: 4.5,
    slug: "Kashmir",
  },
  {
    title: "Family Vacation in Pahalgam",
    description:
      "Enjoy a fun-filled family vacation in Pahalgam with activities like pony rides, river rafting, and sightseeing tours.",
    image: {
      src: "/images/packages/family.jpg",
      alt: "Family Vacation in Pahalgam",
    },
    rating: 4.6,
    slug: "Pahalgam",
  },
  {
    title: "Photography Tour in Kashmir",
    description:
      "Capture the breathtaking beauty of Kashmir with our guided photography tour, perfect for both amateur and professional photographers.",
    image: {
      src: "/images/packages/photograph.jpg",
      alt: "Photography Tour in Kashmir",
    },
    rating: 4.8,
    slug: "Kashmir",
  },
  {
    title: "Luxury Houseboat Experience on Nigeen Lake",
    description:
      "Relax in the lap of luxury on a houseboat in Nigeen Lake, known for its crystal-clear waters and serene environment.",
    image: {
      src: "/images/packages/houseboat.jpg",
      alt: "Luxury Houseboat Experience on Nigeen Lake",
    },
    rating: 4.9,
    slug: "Srinagar",
  },
  {
    title: "Trekking in Pahalgam",
    description:
      "Explore the scenic beauty of Betaab Valley and Aru Valley with guided trekking tours in Pahalgam.",
    image: {
      src: pahalgamImg,
      alt: "Trekking in Pahalgam",
    },
    rating: 4.7,
    slug: "Pahalgam",
  },
  {
    title: "Camping in Sonmarg",
    description:
      "Enjoy an overnight camping experience amidst the snow-capped peaks and meadows of Sonmarg.",
    image: {
      src: "/images/packages/camping.jpg",
      alt: "Camping in Sonmarg",
    },
    rating: 4.6,
    slug: "Sonmarg",
  },
  {
    title: "Snowboarding in Drung",
    description:
      "Join our snowboarding sessions in Drung, a popular destination for winter sports enthusiasts.",
    image: {
      src: drungImg,
      alt: "Snowboarding in Drung",
    },
    rating: 4.6,
    slug: "Drung",
  },
  {
    title: "Photography Tour in Gulmarg",
    description:
      "Capture the stunning beauty of Gulmarg’s snow-capped peaks and meadows on our photography tour.",
    image: {
      src: gulmargImg,
      alt: "Photography Tour in Gulmarg",
    },
    rating: 4.7,
    slug: "Gulmarg",
  },
  {
    title: "Gurez Valley Exploration",
    description:
      "Explore the pristine beauty of Gurez Valley, with trekking and camping experiences in this remote paradise.",
    image: {
      src: "/images/packages/gurez.jpg",
      alt: "Gurez Valley Exploration",
    },
    rating: 4.9,
    slug: "Gurez",
  },
  {
    title: "Houseboat Stay in Nigeen Lake",
    description:
      "Experience luxury and tranquility in a houseboat at Nigeen Lake, offering a serene escape from the hustle of city life.",
    image: {
      src: dalImg,
      alt: "Houseboat Stay in Nigeen Lake",
    },
    rating: 4.8,
    slug: "Srinagar",
  },

  {
    title: "Trekking in Nubra Valley",
    description:
      "Embark on a thrilling trekking adventure through the sand dunes and monasteries of Nubra Valley, with views of the stunning Diskit Monastery and Hunder Village.",
    image: {
      src: "/images/packages/nubra.jpg", // Use an appropriate image
      alt: "Trekking in Nubra Valley",
    },
    rating: 4.7,
    slug: "Ladakh",
  },
  {
    title: "Camping at Pangong Lake",
    description:
      "Experience the beauty of Pangong Lake with a unique camping experience by its shores, perfect for stargazing and soaking in the changing hues of the lake.",
    image: {
      src: "/images/packages/pangong.jpg", // Use an appropriate image
      alt: "Camping at Pangong Lake",
    },
    rating: 4.8,
    slug: "Ladakh",
  },
  {
    title: "Visit Khardung La Pass",
    description:
      "Ride or drive to the world’s highest motorable pass, Khardung La, and enjoy panoramic views of the surrounding Himalayan ranges.",
    image: {
      src: "/images/packages/khar.jpg", // Use an appropriate image
      alt: "Visit Khardung La Pass",
    },
    rating: 4.9,
    slug: "Ladakh",
  },

  {
    title: "Mughal Garden Tour",
    description:
      "Explore the beautiful Mughal Gardens like Nishat Bagh and Shalimar Bagh, known for their rich history and stunning beauty.",
    image: {
      src: "/images/packages/mughal.jpg",
      alt: "Mughal Garden Tour",
    },
    rating: 4.7,
    slug: "Srinagar",
  },
  {
    title: "Kashmir Heritage Walk",
    description:
      "Take a guided walking tour through the old city of Srinagar, exploring its ancient temples, heritage sites, and local handicrafts.",
    image: {
      src: "/images/packages/heritage.jpg",
      alt: "Kashmir Heritage Walk",
    },
    rating: 4.8,
    slug: "Srinagar",
  },
  {
    title: "Srinagar Local Cuisine Tour",
    description:
      "Experience the flavors of Kashmir with a local cuisine tour, including famous dishes like Rogan Josh, Yakhni, and Gushtaba.",
    image: {
      src: "/images/packages/kahwa.jpg",
      alt: "Srinagar Local Cuisine Tour",
    },
    rating: 4.9,
    slug: "Srinagar",
  },

  // **Pahalgam**
  {
    title: "Betaab Valley Visit",
    description:
      "Visit Betaab Valley, named after the Bollywood movie, and enjoy the stunning landscapes and nature walks.",
    image: {
      src: "/images/packages/bungus.jpg",
      alt: "Betaab Valley Visit",
    },
    rating: 4.8,
    slug: "Pahalgam",
  },
  {
    title: "River Rafting in Pahalgam",
    description:
      "For thrill-seekers, experience river rafting in the Lidder River, surrounded by scenic beauty.",
    image: {
      src: "/images/packages/rafting.jpg",
      alt: "River Rafting in Pahalgam",
    },
    rating: 4.7,
    slug: "Pahalgam",
  },

  // **Gurez**
  {
    title: "Gurez Valley Trekking",
    description:
      "Explore the rugged beauty of Gurez Valley with a guided trekking experience through untouched landscapes and remote villages.",
    image: {
      src: "/images/packages/kashmir.jpg",
      alt: "Gurez Valley Trekking",
    },
    rating: 4.9,
    slug: "Gurez",
  },
  {
    title: "Cultural Exploration of Gurez",
    description:
      "Immerse yourself in the local culture of Gurez Valley, interacting with the tribal communities and learning about their traditions.",
    image: {
      src: dalImg,
      alt: "Cultural Exploration of Gurez",
    },
    rating: 4.8,
    slug: "Gurez",
  },

  // **Doodhpathri**
  {
    title: "Doodhpathri Nature Walk",
    description:
      "Take a scenic walk through Doodhpathri, a serene meadow known for its green grasslands and surrounding forests.",
    image: {
      src: "/images/packages/honeymoon.jpg",
      alt: "Doodhpathri Nature Walk",
    },
    rating: 4.7,
    slug: "Doodhpathri",
  },
  {
    title: "Picnic in Doodhpathri",
    description:
      "Enjoy a peaceful picnic in the lush meadows of Doodhpathri, perfect for relaxation and nature lovers.",
    image: {
      src: "/images/packages/manasbal.jpg",
      alt: "Picnic in Doodhpathri",
    },
    rating: 4.6,
    slug: "Doodhpathri",
  },

  // **Yusmarg**
  {
    title: "Yusmarg Hiking Adventure",
    description:
      "Trek through the enchanting meadows of Yusmarg, surrounded by tall trees and stunning views of the snow-covered peaks.",
    image: {
      src: "/images/packages/trek.jpg",
      alt: "Yusmarg Hiking Adventure",
    },
    rating: 4.7,
    slug: "Yusmarg",
  },
  {
    title: "Yusmarg Picnic Day",
    description:
      "Relax and unwind in Yusmarg with a family-friendly picnic amidst the beautiful landscape.",
    image: {
      src: "/images/packages/bungus3.jpg",
      alt: "Yusmarg Picnic Day",
    },
    rating: 4.6,
    slug: "Yusmarg",
  },

  // **Aharbal**
  {
    title: "Aharbal Trek",
    description:
      "Embark on a trekking journey to Aharbal, one of Kashmir's hidden gems, with scenic views and untouched natural beauty.",
    image: {
      src: "/images/packages/arahbal.jpg",
      alt: "Aharbal Trek",
    },
    rating: 4.7,
    slug: "Aharbal",
  },
  {
    title: "Fishing in Aharbal",
    description:
      "Enjoy peaceful fishing in the crystal-clear waters of Aharbal, a haven for nature enthusiasts.",
    image: {
      src: "/images/packages/fishing.jpg",
      alt: "Fishing in Aharbal",
    },
    rating: 4.6,
    slug: "Aharbal",
  },

  // **Manasbal**
  {
    title: "Manasbal Lake Boating",
    description:
      "Take a boat ride in Manasbal Lake, one of Kashmir's deepest lakes, offering stunning views and peaceful surroundings.",
    image: {
      src: "/images/packages/manasbal.jpg",
      alt: "Manasbal Lake Boating",
    },
    rating: 4.8,
    slug: "Manasbal",
  },
  {
    title: "Birdwatching at Manasbal Lake",
    description:
      "Enjoy a birdwatching experience at Manasbal Lake, known for its diverse bird species and tranquil environment.",
    image: {
      src: "/images/packages/bungus2.jpg",
      alt: "Birdwatching at Manasbal Lake",
    },
    rating: 4.7,
    slug: "Manasbal",
  },

  // **Bungus Valley**
  {
    title: "Bungus Valley Trekking",
    description:
      "Trek through the remote Bungus Valley, offering a unique experience of unexplored nature and majestic landscapes.",
    image: {
      src: "/images/packages/trek.jpg",
      alt: "Bungus Valley Trekking",
    },
    rating: 4.8,
    slug: "Bangus",
  },
  {
    title: "Camping in Bungus Valley",
    description:
      "Experience camping in Bungus Valley, surrounded by untouched beauty and a starlit sky.",
    image: {
      src: "/images/packages/camping.jpg",
      alt: "Camping in Bungus Valley",
    },
    rating: 4.9,
    slug: "Bangus",
  },
];
